import type { BackendEntitiesFromBackend } from '../types';

// ---

export function transformCategories(
  responseValue: BackendEntitiesFromBackend['diff'],
): BackendEntitiesFromBackend {
  return { topic: 'prematch-categories', diff: responseValue };
}
